module.exports = {
  projectId: 'iaemwymj',
  dataset: 'production',
};
